import React from "react"
import RadioUnchecked from "assets/icons/RadioUnchecked.svg"
import RadioBlue from "assets/icons/RadioChecked.svg"

const DMVRadioButton = ({ checked, ...props }) => (
  <img {...props} src={checked ? RadioBlue : RadioUnchecked} alt="" />
)

export default DMVRadioButton
